<div class="site-popup" data-tone="info">
  <h2 mat-dialog-title class="site-popup-title">{{ title }}</h2>
  <div class="site-popup-body" [formGroup]="titleForm">
    <p class="site-popup-message">{{ descrizione }}</p>
    <div class="field-block">
      <label for="articleTitle">Titolo</label>
      <input id="articleTitle" class="field" type="text" formControlName="articleTitle"
        [class.is-invalid]="titleForm.invalid && (submitted || titleForm.dirty)">
      @if (titleForm.invalid && (submitted || titleForm.dirty)) {
        <p class="field-error">Il titolo non può essere vuoto.</p>
      }
    </div>
    <p class="title-examples">
      Esempio titolo per salvare anche la data:<br>
      YYYY nome<br>
      YYYY-YYYY nome<br>
      YYYYMMDD nome
    </p>
  </div>
  <div class="site-popup-actions">
    <button class="site-popup-ghost" type="button" (click)="buttonClose()">Chiudi</button>
    <button class="site-popup-action" type="button" (click)="buttonAction()">Copia e cancella</button>
  </div>
</div>
